export function trimBaseName(routerBaseName: string, url: string): string {
  return url.replace(routerBaseName, '');
}
